import Joi from '@hapi/joi'

export const RoleFilterSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Operatin Entity cannot have invalid characters`,
        "any.required": `Operatin Entity required`
    }),  
}

export const RoleEditSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group  cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Operatin Entity cannot have invalid characters`,
        "any.required": `Operatin Entity required`
    }),
    roleLevel: Joi.number().invalid(0).required().label("Role Level").messages({
        "any.invalid": `Role Level cannot have invalid characters`,
        "any.required": `Role Level required`
    }),
    name: Joi.string().required().label("Name").messages({
        "string.empty": `Role Name  required`,
        "string.pattern.base": `Please enter valid Role Name`,
    }),
    isActive: Joi.boolean().label("Active")
}